// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__WzJGm","title":"ClientReferral_title__2IVJv","itemText":"ClientReferral_itemText__2FNmb"};